// import { slideUp, slideDown } from "../helper/slide-toggle";

const processNewsletter = () => {
    let emailField = document.getElementById('email-address');
    let agreementCheckbox = document.getElementById('agreement-checkbox');
    let emailValue = emailField.value;
    if (!emailValue) {
        emailField.focus();
        return false;
    }
    if (!agreementCheckbox.checked) {
        agreementCheckbox.focus();
        return false;
    }
    let mailchimpPayload = { nonce: lsApi.options.nonce };
    mailchimpPayload.email = emailValue;
    mailchimpPayload.fname = (Math.random() + 1).toString(36).substring(7);
    mailchimpPayload.lname = (Math.random() + 1).toString(36).substring(7);
    lsApi.registerMailChimpSubscription(mailchimpPayload, (jqxhr, status) => {
        // let response = JSON.parse(jqxhr.responseText);
        // response.msg (text from mailchimp)
        // status (success OK)
        if (status === 'success') {
            document.querySelector('[data-modal-target="default-modal"]').click();
        }
    });
};

document.addEventListener('DOMContentLoaded', function () {
    let signupButton = document.querySelector('.signup-button');
    if (signupButton) {
        signupButton.addEventListener('click', () => {
            processNewsletter();
        });
    }
});
